/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcDtccCnsV1AssetDayEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_DTCC_CNS_V1_ASSET_DAY_EVENT_ENTITY_NAME = 'ixc.dtcc.cns.v1.AssetDayEvent';
export const ixcDtccCnsV1AssetDayEventEntity = new schema.Entity<IxcDtccCnsV1AssetDayEvent>(IXC_DTCC_CNS_V1_ASSET_DAY_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcDtccCnsV1AssetDayEvent) => `${entity.metadata?.eventId}` });

